import { ProjectsLayoutComponent } from '@/components';



const Projects = () => {

  return (
    <>
      <ProjectsLayoutComponent />
    </>
  );
};

export {Projects};
